import {Injectable, inject} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import * as PL2 from '@common/utils/dist/models/models-pl2.js';

import {S3Service} from '@services/s3.service';

import {Action} from './action';

/** A saved trial's plots by its S3 key (a trial entry's pP), as the trial card loads them. */
@Injectable({providedIn: 'root'})
export class LoadTrialPlotsAction implements Action<
  string,
  PL2.Plot[] | undefined
> {
  private _s3Service = inject(S3Service);

  execute(s3Key: string): Observable<PL2.Plot[] | undefined> {
    if (!s3Key) return of(undefined);
    return this._s3Service.getImageOrTrial(s3Key).pipe(
      map((body) => (body ? (JSON.parse(body) as PL2.Plot[]) : undefined)),
      catchError((err: unknown) => {
        console.warn('[LoadTrialPlots] could not read trial', s3Key, err);
        return of(undefined);
      }),
    );
  }
}
